import type { HelpFile } from '../../types/help'
import { ScriptConfigCardTestIds } from '../../../testids/ScriptConfigCardTestIds'

export const scriptConfigCardHelp: HelpFile = {
  docPage: '/docs/connectors/script-connector',
  texts: {
    [ScriptConfigCardTestIds.scriptConfigCard]:
      'Konfiguration eines ausgehenden skriptbasierten Konnektors — legt die vom Skript implementierten Operationen und deren Aufruf fest.',
    [ScriptConfigCardTestIds.cardTitleScriptConfig]: null,
    [ScriptConfigCardTestIds.btnCreateScriptConfig]: null,
    [ScriptConfigCardTestIds.btnEditScriptConfig]: null,
    [ScriptConfigCardTestIds.btnValidateScript]:
      'Probelauf gegen den Skript-Endpunkt zur Konfigurationsprüfung — ohne Änderungen vorzunehmen.',
  },
}
